// Detail builder for the force-logout audit trail (kept separate to respect the 100-line rule).
import { localDateTime } from "../../../lib/datetime";
export const DETAILS_C = {
  revocations: (d, t) => ({
    title: t("system.revocations"),
    summary: [
      [t("system.revokedTotal"), d.total],
      [t("system.rowsCount", { count: d.items.length }), d.items.length],
    ],
    columns: [t("system.user"), t("system.revokedBy"), t("system.when")],
    rows: d.items.map((i) => [i.user, i.by, localDateTime(i.at)]),
  }),
};
